<template>
  <div class="enreach-cardhead">
    <div class="icon">
      <svg-injector
        :class-name="'js-svg-injector'"
        src="/img/enr.svg"
      ></svg-injector>
    </div>
    <div class="text">Governance Proposals</div>
    <div v-if="true">
      <div class="enreach-panel">
        <div class="text">Coming Soon</div>
      </div>
    </div>
    <div v-else>
      <div class="col-4">
        <div class="enreach-panel">
          <div class="icon">
            <svg-injector
              :class-name="'js-svg-injector'"
              src="/img/enr.svg"
            ></svg-injector>
          </div>
          <div class="text">0.00000000</div>
        </div>
        <div class="enreach-panel">
          <p class="title">Voting Wallet</p>
          <p class="subtitle m0">veABSORB Balance</p>
          <div class="icon">
            <svg-injector
              :class-name="'js-svg-injector'"
              src="/img/enr.svg"
            ></svg-injector>
          </div>
          <div class="text">0.00000000</div>
          <p class="subtitle m0">veABSORB Earned</p>
          <div class="icon">
            <svg-injector
              :class-name="'js-svg-injector'"
              src="/img/enr.svg"
            ></svg-injector>
          </div>
          <div class="text">0.00000000</div>
          <p class="subtitle m0">MULTI Mint Earned</p>
          <div class="icon">
            <svg-injector
              :class-name="'js-svg-injector'"
              src="/img/enr.svg"
            ></svg-injector>
          </div>
          <div class="text">0.00000000</div>
          <div class="flex flex-column setup">
            <p class="setup-header">Setup Voting</p>
            <p class="setup-content">You can either vote on each proposal yourself or delegate your votes to a third party. Venus Governance puts you in charge of the future of Venus.</p>
          </div>
          <div class="center footer">
            <button class="MuiButtonBase-root MuiButton-root MuiButton-text started-btn" tabindex="0" type="button">
              <span class="MuiButton-label">Get Started</span>
              <span class="MuiTouchRipple-root"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="enreach-panel col-sm-8">
          <div class="text">Voting Weight 0.00000000</div>
        </div>
        <div class="enreach-panel">
          <p class="title">Governance Proposals</p>
          <div class="body">
            <div class="sc-caSCKo proposal pointer">
              <div class="title">
                <h1>VIP-48 Support TRON on Venus and Withdraw reserve funds</h1>
              </div>
              <div class="detail">
                <div class="container">
                  <div class="row justify-content-start">
                    <div class="description col">
                      <span>48</span>
                      <span>Active</span>
                      <span>November 24th, 2021</span>
                    </div>
                    <div class="sc-gqjmRU huaWxy description col">
                      <div class="orange-text Active-btn">Active</div>
                      <span>2 days, 11 hrs left</span>
                    </div>
                  </div>
                </div>
                <div class="sc-gqjmRU fISkKD vote-status"></div>
              </div>
            </div>
            <div class="sc-caSCKo proposal pointer">
              <div class="title">
                <h1>VIP47 Support TRON on Venus and Withdraw reserve funds</h1>
              </div>
              <div class="detail">
                <div class="container">
                  <div class="row justify-content-start">
                    <div class="description col">
                      <span>47</span>
                      <span>Queued</span>
                      <span>November 19th, 2021</span>
                    </div>
                    <div class="sc-gqjmRU huaWxy description col">
                      <div class="orange-text Queued-btn">Queued</div>
                      <span>November 22, 2021</span>
                    </div>
                  </div>
                </div>
                <div class="sc-gqjmRU fISkKD vote-status"></div>
              </div>
            </div>
            <div class="sc-caSCKo proposal pointer">
              <div class="title">
                <h1>VIP-46 Disable rewards on XVS market</h1>
              </div>
              <div class="detail">
                <div class="container">
                  <div class="row justify-content-start">
                    <div class="description col">
                      <span>46</span>
                      <span>Executed</span>
                      <span>November 2nd, 2021</span>
                    </div>
                    <div class="sc-gqjmRU huaWxy description col">
                      <div class="orange-text Passed-btn">Passed</div>
                      <span>November 07, 2021</span>
                    </div>
                  </div>
                </div>
                <div class="sc-gqjmRU fISkKD vote-status"></div>
              </div>
            </div>
            <div class="sc-caSCKo proposal pointer">
              <div class="title">
                <h1>
                  VIP-45 Migrate guardian to multi-sig wallet and Payout
                  marketing funds from Treasury
                </h1>
              </div>
              <div class="detail">
                <div class="container">
                  <div class="row justify-content-start">
                    <div class="description col">
                      <span>45</span>
                      <span>Executed</span>
                      <span>October 20th, 2021</span>
                    </div>
                    <div class="sc-gqjmRU huaWxy description col">
                      <div class="orange-text Passed-btn">Passed</div>
                      <span>October 25, 2021</span>
                    </div>
                  </div>
                </div>
                <div class="sc-gqjmRU fISkKD vote-status"></div>
              </div>
            </div>
            <div class="sc-caSCKo proposal pointer">
              <div class="title"><h1>Release DeFireX Funds</h1></div>
              <div class="detail">
                <div class="container">
                  <div class="row justify-content-start">
                    <div class="description col">
                      <span>44</span>
                      <span>Executed</span>
                      <span>October 1st, 2021</span>
                    </div>
                    <div class="sc-gqjmRU huaWxy description col">
                      <div class="orange-text Passed-btn">Passed</div>
                      <span>October 06, 2021</span>
                    </div>
                  </div>
                </div>
                <div class="sc-gqjmRU fISkKD vote-status"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div role="document" class="modal connect-modal" style="width: 400px;"><div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden; outline: none;"></div><div class="ant-modal-content"><div class="ant-modal-body"><div class="sc-dVhcbM bpIsnK flex flex-column align-center just-center"><img class="go-back pointer hidden" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNq01D8LQVEcxnH/BimiTLJZpKxSkoGBZCKDSVL2u9iMXoDsImVCMaKUpJTZwJtQKBn4njp3EZZ7z1OfusPpPp1zfh3rfVWyGIgPE7Sx+LfQZjGWK6YYo/FvocNg0RMdHNFHGBpeZu9Ijzi2FLKYw62qSOSEOOzYIqSqSOSCHJbYIaOqSI8m9VDVh6EG57cLNBDxrzvWsiwqisrwKNjVAy75HXPISVGRAGYYoa7qjtI4YIWKOEYVRXX5WrTQNOtl+EwXReSxMfMJ0uPFEEEkcVbxMkSwlyOd+FZiRpEfAzldBdx+LXwLMACQUyvJnORMlAAAAABJRU5ErkJggg==" alt="left arrow"><img class="close-btn pointer" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVlJREFUeNqc07tKA0EUxvHNblDBysrKe8RCSx/AVrygBBVFQXwDCwuxFjsRLDQqRkRJaR7ANDY2aRTFQp/AwlwgFlb+j3wLYdhsEg/8EtiBb3fOnEnk8/kDz/PecO21X0kcouDzc49dbPwj6AwTKFpiAVvI6g3ZFgISuMAwFlBOauER67hCF05iQmwXp+jDPKrhHsMqYg05dOKoQZB9Sao+JEyvr2csYxM7zlqgkAHM2Xbcrrv1iiXcoQP7en6OUYVUoo4vqt7VRNvmD3oxhNmokLggqw+s4EW9GEEt7gTijngbD3jCntfkKBs9t56MI41VTOG4naCE5mRMIbadL/VsUmtNgwJ9iU3sDEp1a5+Y1tql218/4u6kdPzViBeXtdavqxS4QUmFDGoLpZi+VjTVPbjRlfoLspCMhi3tTmyD+tZodOPW/n1Nrs3IYoshYdV0nexwMr8CDADg+kMi6JoPKQAAAABJRU5ErkJggg==" alt="close"><div class=""><div class="flex align-center just-center header-content"><p>Choose Delegation Type</p></div><div class="flex flex-column section"><div class="flex align-center just-between"><div class="flex align-center"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0BJREFUeNrEmEtPU0EUx89MCy1KSgOhgcTHRteFQmPSlakhJmzcucfAxviALoSPAMZEowsi8AlqojEmJobEuMJFjcRWFwY1UQkgNCCILX3cXs/UuVBu5z57L/yTfyY8buaXMzNnzhkCNhT+MUtwCKG70UF0K7qZ/7mI3kX/Rq+i1z+cGZGtzkEsAkVxGEZf5UBmxACT6DkETDkKhkC9OEyhB6AxzaPHEXCxITAE8uEwib6FpuCMKuiH6AkELFgGQ6hTODxHR8AdvUdfQbhl02AIdQ6H1+jT4K5+ouMI98UQjEdq4QigauFi6sgRwZ5acHH59JY1Vrvn1Bt68higgM85KYwYTwnvHDx9dk5rv5JKaiGmjhFKYZk6tJQ8ow+4PfNwoAfON7Xr/csAZ9mP0LDbULfbonCjrR9mQ4NGcFUWwi/kTQt3ny2ooUD44PKs7MHI+ktYKm1q3a3tlFcJRwbFFKR+uNsRB1oRFh2MJUR56XJkUNWQSHuQ+PoCilu7IJcl0afd1Gy0+nxd4CdeR6CGlp7AUn4DQJZB2s6J4IKUF3m6uthyFh53DsKjzsum4PShkv+hFInhWmlN5akJda/jEngJhaiv2xDOGCpb/1E9XDM1Wj4FSpEenC0oDTjKa3ShPhWzsFj8Vfd7EZwW1JaUN4ZSwUFFLlHeOAi1J5fh5sYrSBVWdeH0oK5VN3rW/FFGODlXyLEE24M/6tbgbHIGwWDUWpP+QpfnpDNQXB6/r4/yFktXepETQbE9ZReqKklaZWDr/BqwDWd5o+v3Rzuk7cQa5c1o0swnRnCNQ1ULxKeMSckDc2Y/1II7yOj2oapgHjqzX/bwDnneLtyha6YRKELeZMKjb9UV7Dgvby3Bzee+OQLF5iZA7mh1SfdxGLV8iFjGLpUbixaQ6Y+RxHWtLmmCt1LW8k6gBUiTtxGuNClXEu40vOw62cnbidyKh9BYunfsu7ozOSTeEcd5h2xl59qJ3AoFEldDgVa7xt8SYpaX1RpcmkUqE0l81urlQANumcM9sHJaTcCx0zdNy/IFUaTcf7gT7DmWp1hKyPSOpYxPqZtPnQzuT34bSpVnhJIZJXk69tQpAHT9cfifAAMAtbW5fxdhkycAAAAASUVORK5CYII=" alt="check" class="check-image"><span>Manual Voting</span></div><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNq01D8LQVEcxnH/BimiTLJZpKxSkoGBZCKDSVL2u9iMXoDsImVCMaKUpJTZwJtQKBn4njp3EZZ7z1OfusPpPp1zfh3rfVWyGIgPE7Sx+LfQZjGWK6YYo/FvocNg0RMdHNFHGBpeZu9Ijzi2FLKYw62qSOSEOOzYIqSqSOSCHJbYIaOqSI8m9VDVh6EG57cLNBDxrzvWsiwqisrwKNjVAy75HXPISVGRAGYYoa7qjtI4YIWKOEYVRXX5WrTQNOtl+EwXReSxMfMJ0uPFEEEkcVbxMkSwlyOd+FZiRpEfAzldBdx+LXwLMACQUyvJnORMlAAAAABJRU5ErkJggg==" alt="arrow" class="arrow-image"></div><div class="description">This option allows you to vote on proposals directly from your connected wallet.</div></div><div class="flex flex-column section"><div class="flex align-center just-between"><div class="flex align-center"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0BJREFUeNrEmEtPU0EUx89MCy1KSgOhgcTHRteFQmPSlakhJmzcucfAxviALoSPAMZEowsi8AlqojEmJobEuMJFjcRWFwY1UQkgNCCILX3cXs/UuVBu5z57L/yTfyY8buaXMzNnzhkCNhT+MUtwCKG70UF0K7qZ/7mI3kX/Rq+i1z+cGZGtzkEsAkVxGEZf5UBmxACT6DkETDkKhkC9OEyhB6AxzaPHEXCxITAE8uEwib6FpuCMKuiH6AkELFgGQ6hTODxHR8AdvUdfQbhl02AIdQ6H1+jT4K5+ouMI98UQjEdq4QigauFi6sgRwZ5acHH59JY1Vrvn1Bt68higgM85KYwYTwnvHDx9dk5rv5JKaiGmjhFKYZk6tJQ8ow+4PfNwoAfON7Xr/csAZ9mP0LDbULfbonCjrR9mQ4NGcFUWwi/kTQt3ny2ooUD44PKs7MHI+ktYKm1q3a3tlFcJRwbFFKR+uNsRB1oRFh2MJUR56XJkUNWQSHuQ+PoCilu7IJcl0afd1Gy0+nxd4CdeR6CGlp7AUn4DQJZB2s6J4IKUF3m6uthyFh53DsKjzsum4PShkv+hFInhWmlN5akJda/jEngJhaiv2xDOGCpb/1E9XDM1Wj4FSpEenC0oDTjKa3ShPhWzsFj8Vfd7EZwW1JaUN4ZSwUFFLlHeOAi1J5fh5sYrSBVWdeH0oK5VN3rW/FFGODlXyLEE24M/6tbgbHIGwWDUWpP+QpfnpDNQXB6/r4/yFktXepETQbE9ZReqKklaZWDr/BqwDWd5o+v3Rzuk7cQa5c1o0swnRnCNQ1ULxKeMSckDc2Y/1II7yOj2oapgHjqzX/bwDnneLtyha6YRKELeZMKjb9UV7Dgvby3Bzee+OQLF5iZA7mh1SfdxGLV8iFjGLpUbixaQ6Y+RxHWtLmmCt1LW8k6gBUiTtxGuNClXEu40vOw62cnbidyKh9BYunfsu7ozOSTeEcd5h2xl59qJ3AoFEldDgVa7xt8SYpaX1RpcmkUqE0l81urlQANumcM9sHJaTcCx0zdNy/IFUaTcf7gT7DmWp1hKyPSOpYxPqZtPnQzuT34bSpVnhJIZJXk69tQpAHT9cfifAAMAtbW5fxdhkycAAAAASUVORK5CYII=" alt="check" class="check-image"><span>Delegate Voting</span></div><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNq01D8LQVEcxnH/BimiTLJZpKxSkoGBZCKDSVL2u9iMXoDsImVCMaKUpJTZwJtQKBn4njp3EZZ7z1OfusPpPp1zfh3rfVWyGIgPE7Sx+LfQZjGWK6YYo/FvocNg0RMdHNFHGBpeZu9Ijzi2FLKYw62qSOSEOOzYIqSqSOSCHJbYIaOqSI8m9VDVh6EG57cLNBDxrzvWsiwqisrwKNjVAy75HXPISVGRAGYYoa7qjtI4YIWKOEYVRXX5WrTQNOtl+EwXReSxMfMJ0uPFEEEkcVbxMkSwlyOd+FZiRpEfAzldBdx+LXwLMACQUyvJnORMlAAAAABJRU5ErkJggg==" alt="arrow" class="arrow-image"></div><div class="description">This option allows you to delegate your votes to another Ethereum address. You never send Venus, only your voting rights, and can undelegate at any time.</div></div></div></div></div></div><div tabindex="0" aria-hidden="true" style="width: 0px; height: 0px; overflow: hidden; outline: none;"></div></div>
</template>

<script>
export default {
  name: "GovernanceStaking",
  data() {
    return {};
  },
  methods: {
  },
};
</script>
<style scoped>
p.title {
  font-weight: 700;
  font-size: 1.2em;
}
.title * {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px;
    font-weight: 900;
    color: #37ecba;
}
p.subtitle {
  padding: 0;
  margin: 0;
}
.proposal{
    width: 100%;
    padding: 15px 0px;
    border-bottom: 1px solid #126e99;
    flex-direction: column;
    display: flex;
}
.proposal .description {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 0px 10px;
}
.proposal .detail{
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
}
</style>